<shared-wizzard-wrapper [type]="type">

    <shared-wizzard-special-instructions *ngIf="(showSpecialInstructions$ | async)" [type]="type"
        [isExpanded]="hasSpecialInstructions$ | async">
    </shared-wizzard-special-instructions>

    <shared-disclaimer class="wizzard-for-product__disclaimer" *ngIf="showDisclaimer"></shared-disclaimer>

    <shared-wizzard-quantity *ngIf="(showQuantityWizard$ | async)" [mobile]="quantityMobile" [desktop]="quantityDesktop" [type]="type">
    </shared-wizzard-quantity>

</shared-wizzard-wrapper>
